export default __webpack_public_path__ + "static/media/zona-grill.3926277d.jpg";